module.exports = __webpack_public_path__ + "img/phone-list-shop.109b2f07.webp";